export enum ContactPersonTypeEnum {
    CONTACT = 'CONTACT', EINVOICE = 'EINVOICE', REPORT = 'REPORT', ORGANIZATION = 'ORGANIZATION', ORDER = 'ORDER'
}
